import { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const AUTO_HIDE_MS = 10000;

interface NarrativeOverlayProps {
  text: string | null;
}

export function NarrativeOverlay({ text }: NarrativeOverlayProps) {
  const [visible, setVisible] = useState(false);
  const [displayText, setDisplayText] = useState('');
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (text) {
      setDisplayText(text);
      setVisible(true);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setVisible(false), AUTO_HIDE_MS);
    } else {
      setVisible(false);
    }
    return () => clearTimeout(timerRef.current);
  }, [text]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.4 }}
          className="absolute top-3 left-0 right-0 z-20 flex justify-center pointer-events-none"
        >
          <div className="bg-gray-900/95 backdrop-blur-xl border border-gray-600/40 rounded-xl px-6 py-2.5 text-base text-gray-50 shadow-2xl">
            {displayText}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
